<template>
  <div v-cloak>
    <div class="container container-fluid bg--cardio">
      <h1 class="pull-left text-muted">Alla kardiologpatienter - {{ noOfAllCardioPatients }} st</h1>
      <router-link to="/newcardio">
        <button class="btn btn-info btn-sm top-right">Skapa ny kardiologpatient</button>
      </router-link>
      <div class="clearfix"></div>
      <div class="table-responsive">
      <vue-good-table
        :columns="columns"
        :rows="allCardioPatients"
        :search-options="{
          enabled: true,
          placeholder: 'Sök',
        }"
        :pagination-options="{
          enabled: true,
          perPage: 50,
          position: 'top',
          firstLabel : 'Första sidan',
          lastLabel : 'Sista sidan',
          nextLabel: 'Nästa',
          prevLabel: 'Föregående',
          rowsPerPageLabel: 'Patienter per sida',
          ofLabel: 'av',
          pageLabel: 'sida',
          allLabel: 'Alla'
        }"
        :sort-options="{
          enabled: true,
          initialSortBy: [
            { field: 'personId', type: 'asc' },
          ]
        }">
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'personId'">
            <router-link
              :to="{ name: 'patientcardio', params: { id: (props.row.personId) }}"
              v-if="props.row.personId">
              {{ props.row.personId }}
            </router-link>
          </span>
          <span v-else-if="props.column.field == 'ssn'">
            <details>
              <summary>Personnummer</summary>
              {{ formatPnr(props.row.ssn) }}
            </details>
          </span>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
        <div slot="emptystate">
          Det finns inga kardiologpatienter
        </div>
      </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
import config from '../../config/index.js'
import axios from '../plugins/axios'
import $ from 'jquery'

export default {
  name: 'allpatientscardio',
  components: {
  },
  data () {
    return {
      allCardioPatients: [],
      columns: [
        {
          label: 'Pat#',
          field: 'personId',
          type: 'number'
        },
        {
          label: 'PNR',
          field: 'ssn',
          type: 'text'
        },
        {
          label: 'Efternamn',
          field: 'lastName',
          type: 'text'
        },
        {
          label: 'Förnamn',
          field: 'firstName',
          type: 'text'
        },
        {
          label: 'Mutation',
          field: 'mutation',
          type: 'text'
        },
        {
          label: 'Relation',
          field: 'status',
          type: 'text'
        },
        {
          label: 'Registrerad av',
          field: 'clinician',
          type: 'text'
        },
        {
          label: 'Klinik',
          field: 'clinicName',
          type: 'text'
        },
        {
          label: 'Ursprungsklinik',
          field: 'originalClinic',
          type: 'text'
        }
      ]
    }
  },
  methods: {
    toTitleCase (phrase) {
      if (phrase) {
        return phrase
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      }
    },
    formatPnr (ssn) {
      if (ssn) {
        const output = ssn.substring(0, 4) + '-' +
                      ssn.substring(4, 6) + '-' +
                      ssn.substring(6, 8) + '-' +
                      ssn.substring(8, 12)
        return output
      }
      return '-'
    },
    getAllCardioPatients () {
      let loader = this.$loading.show()
      axios._get(config.cardioUri + config.allUri).then(response => {
        this.allCardioPatients = response.data.allCardioPatients
          ? response.data.allCardioPatients : []
        loader.hide()
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get all patients: ' + error)
          loader.hide()
        }
      })
    }
  },
  computed: {
    noOfAllCardioPatients () {
      if (this.allCardioPatients) {
        return this.allCardioPatients.length
      }
      return 0
    }
  },
  created () {
    setTimeout(() => {
      $('.vgt-table').css('font-size', '14px')
    })
  },
  beforeMount () {
    this.getAllCardioPatients()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.pull-left {
  text-align: left;
}
.top-right {
  position: absolute;
  top: 0px;
  right: 0px;
  margin-top: 11vh;
  margin-right: .8vw;
}
</style>



// WEBPACK FOOTER //
// src/components/AllPatientsCardio.vue